import { render, staticRenderFns } from "./LegalTermsIMADenuncie.vue?vue&type=template&id=6b60e940&scoped=true&"
import script from "./LegalTermsIMADenuncie.vue?vue&type=script&lang=js&"
export * from "./LegalTermsIMADenuncie.vue?vue&type=script&lang=js&"
import style0 from "./LegalTermsIMADenuncie.vue?vue&type=style&index=0&id=6b60e940&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b60e940",
  null
  
)

export default component.exports